/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Situationadddefect2Inputs */

const en_situationadddefect2 = /** @type {(inputs: Situationadddefect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell the assistant about the first defect you noticed`)
};

const pt_situationadddefect2 = /** @type {(inputs: Situationadddefect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte ao assistente o primeiro defeito que reparou`)
};

/**
* | output |
* | --- |
* | "Tell the assistant about the first defect you noticed" |
*
* @param {Situationadddefect2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const situationadddefect2 = /** @type {((inputs?: Situationadddefect2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Situationadddefect2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_situationadddefect2(inputs)
	return pt_situationadddefect2(inputs)
});
export { situationadddefect2 as "situationAddDefect" }